import React from 'react';
import FeatureCards from "../../../../components/FeatureCards/FeatureCards";
import CTA from "../../../../components/Constant/cta/CTA";
import TimelineSection from "../../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../../components/WhySection/WhySection";
import LocationTimeline from "../../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../../components/IntroSection/IntroSection";
import FAQList from "../../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../../components/ServiceCards/ServiceCards";
import SEO from "../../../../utils/SEO";

export default function TrustCompanyLicensePanama() {

    return (
        <main className='main'>
            <SEO
                title=""
                description=""
                keywords=""
                url="/trust-company-license-panama"
            />

            <IntroSection
                title="Trust Company License – Panama"
                subtitle="Establish a Licensed Trust Company in a Global Fiduciary Hub"
                description="Panama is globally recognized for its trust law and fiduciary services, offering one of the most flexible and protective trust regimes worldwide. Trust companies in Panama are licensed and regulated by the Superintendence of Banks of Panama, ensuring compliance and international credibility. With Panama’s territorial tax system and respected Trust Law, it is an ideal jurisdiction for wealth management firms, family offices, and fiduciary service providers."
                badges={[
                    "Asset Protection",
                    "Estate Planning",
                    "Corporate Fiduciary Services",
                    "Family Offices"
                ]}
                buttonText="Request a Panama Trust Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../../../assets/images/services/panama-trust.png")}
                imageAlt="Panama Trust Company License"
            />

            <section className='section'>
                <div className="container">

                    <WhySection
                        title='Why Choose Panama for Trust Services?'
                        blocks={[
                            {
                                items: [
                                    {
                                        title: "Global Recognition",
                                        text: "Panama trusts are respected worldwide."
                                    },
                                    {
                                        title: "Strong Legal Framework",
                                        text: "Trust Law (1984) offers flexibility and protection."
                                    },
                                    {
                                        title: "Asset Protection",
                                        text: "Shields assets from creditors and political risk."
                                    },
                                    {
                                        title: "Tax Benefits",
                                        text: "Foreign-sourced trust income is exempt from taxation."
                                    },
                                    {
                                        title: "Versatile Structures",
                                        text: "Used for families, corporates, funds, and investors."
                                    }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="What Can a Licensed Trust Company Do?"
                        blocks={[
                            {
                                title: "Trustee Services",
                                items: [
                                    { text: "Act as trustee for private and commercial trusts." },
                                    { text: "Manage estate planning and succession structures." },
                                    { text: "Provide fiduciary management for corporates." }
                                ]
                            },
                            {
                                title: "Asset & Investment Management",
                                items: [
                                    { text: "Hold and manage assets, investments, and real estate." },
                                    { text: "Act as custodian for securities and financial instruments." }
                                ]
                            },
                            {
                                title: "Family Office Services",
                                items: [
                                    { text: "Offer comprehensive family office support for HNWIs." }
                                ]
                            }
                        ]}
                    />

                    <LocationTimeline
                        title="Capital & Compliance Requirements"
                        item={[
                            {
                                title: "Minimum Paid-Up Capital",
                                text: "USD 1,000,000."
                            },
                            {
                                title: "Local Presence",
                                text: "Panama entity required with licensed trust officers."
                            },
                            {
                                title: "Fit & Proper Test",
                                text: "Applied to shareholders, directors, and managers."
                            },
                            {
                                title: "Compliance",
                                text: "AML/KYC framework aligned with FATF standards."
                            },
                            {
                                title: "Supervision",
                                text: "Regulated by the Superintendence of Banks of Panama."
                            }
                        ]}
                    />

                    <ServiceCards
                        title='Benefits of a Panama Trust Company License'
                        services={[
                            {
                                title: "Global Trust Recognition",
                                text: "One of the strongest fiduciary reputations in Latin America."
                            },
                            {
                                title: "Asset Protection",
                                text: "Panama trusts shield assets from seizure and litigation."
                            },
                            {
                                title: "Private & Flexible",
                                text: "Trusts can be confidential and highly customizable."
                            },
                            {
                                title: "Tax Neutrality",
                                text: "Foreign trust income is exempt from local taxation."
                            },
                            {
                                title: "Corporate Uses",
                                text: "Trusts may be combined with funds, insurance, and banking structures."
                            }
                        ]}
                    />

                    <FeatureCards
                        title='Licensing Process'
                        features={[
                            {
                                title: "Pre-Application Consultation",
                                text: "Define scope: private, family office, or corporate trustee services."
                            },
                            {
                                title: "Company Incorporation",
                                text: "Establish a Panamanian legal entity."
                            },
                            {
                                title: "Application Submission",
                                text: "Prepare business plan, AML/KYC manuals, and trust deed samples."
                            },
                            {
                                title: "Regulatory Review",
                                text: "Conducted by the Superintendence of Banks of Panama."
                            },
                            {
                                title: "Approval & Licensing",
                                text: "Typically completed in 6–9 months."
                            }
                        ]}
                    />

                    <TimelineSection
                        title='Timeline & Costs'
                        items={[
                            {
                                name: "Timeline",
                                duration: "6–9 months."
                            },
                            {
                                name: "Setup Costs",
                                description: "from USD 80,000+ (legal, compliance, advisory)."
                            },
                            {
                                name: "Capital Requirement",
                                description: "USD 1,000,000 minimum."
                            },
                            {
                                name: "Annual Costs",
                                description: "Compliance, reporting, audits, and regulator fees."
                            }
                        ]}
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={[
                            {
                                text: "Experts in fiduciary and trust licensing."
                            },
                            {
                                text: "End-to-end support: incorporation, license filing, compliance manuals."
                            },
                            {
                                text: "Structuring guidance for family offices, corporate trusts, and estate planning."
                            },
                            {
                                text: "Global comparison: Panama vs Western Sahara vs Mwali vs EU trust regimes."
                            },
                            {
                                text: "Long-term compliance and fiduciary management support."
                            }
                        ]}
                    />


                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Looking to launch a licensed trust company in Panama?"
                        description="Panama offers a USD 1M trust license regime under a respected regulator, delivering asset protection, tax neutrality, and strong global recognition."
                        buttonText="Book a Panama Trust Consultation →"
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "Is IoM part of the UK?",
        answer: "No — it is a self-governing British Crown Dependency, but residents enjoy many UK-linked benefits.",
    },
    {
        question: "Can IoM residency lead to UK citizenship?",
        answer: "Yes — through long-term residency and naturalization.",
    },
    {
        question: "How much do I need to invest?",
        answer: "GBP 2m+ for Investor Visa, GBP 50k+ for Entrepreneur route.",
    },
    {
        question: "Is IoM tax efficient?",
        answer: "Yes — 0% corporate tax, no CGT, no inheritance tax.",
    },
    {
        question: "How long does the process take?",
        answer: "2–6 months, depending on residency route.",
    },
];


const testimonialsData =
    [
        {
            quote: "We established a licensed trust company in Panama with Offshore Advisory. It gave our family office global credibility.",
            author: "Javier G.",
            role: "Wealth Manager"
        },
        {
            quote: "Panama trusts remain one of the strongest tools for asset protection. Offshore Advisory made the licensing process smooth.",
            author: "Laura P.",
            role: "Fiduciary Advisor"
        }

    ]
;
